// @flow

import { selectFeatureFlag } from '@gandi/authentication';

import { useAppSelector } from './useAppSelector';

export const useFeatureFlag = (
  featureFlagName: StringPrefix<'FF_'> | StringPrefix<'ff-'>,
): boolean => {
  const featureFlag = useAppSelector(state =>
    selectFeatureFlag(state, {
      featureFlagName,
    }),
  );

  return featureFlag;
};
